import React from "react";
import { Modal } from "./Modal";

export const ModalGenerator = props =>
  props.rows.map(row => {
    return <Modal
      modalid={"modal_" + row.id}
      id={row.id}
      title={props.title}
      description={props.description}
      cancelLabel={props.cancelLabel}
      confirmLabel={props.confirmLabel}
      onClick={props.onClick}
    />
  })
